import { useCallback, useState } from 'react';

import { TypewriterOnce } from '../../components/TypewriterOnce';

import { MemoryImportPasteForm } from './MemoryImportPasteForm';
import { PROVIDERS, type Provider } from './providers';

type MemoryImportPasteScreenProps = {
	provider: Provider;
	websiteUrl?: string | null;
	instagramHandle?: string | null;
	// Re-seeds the textarea when the user navigates back here: the wizard
	// remounts screens on every transition, so local state doesn't survive.
	initialSnippet?: string;
	onSubmit: (snippet: string) => void;
	onSkip: () => void;
};

export const MemoryImportPasteScreen = ({
	provider,
	websiteUrl,
	instagramHandle,
	initialSnippet,
	onSubmit,
	onSkip,
}: MemoryImportPasteScreenProps) => {
	const [typingDone, setTypingDone] = useState(false);
	const handleTypingDone = useCallback(() => setTypingDone(true), []);

	const { label } = PROVIDERS[provider];

	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="w-full max-w-[760px] px-8">
				<h2
					className="mb-4"
					style={{
						fontSize: 'clamp(26px, 4vw, 40px)',
						fontWeight: 700,
						letterSpacing: '-0.02em',
						lineHeight: 1.15,
						color: 'var(--text-primary)',
					}}
				>
					<TypewriterOnce
						text={`Paste your export from ${label}.`}
						onDone={handleTypingDone}
					/>
				</h2>

				<div
					style={{
						opacity: typingDone ? 1 : 0,
						transition: 'opacity 400ms ease',
						pointerEvents: typingDone ? 'auto' : 'none',
					}}
				>
					<MemoryImportPasteForm
						provider={provider}
						websiteUrl={websiteUrl}
						instagramHandle={instagramHandle}
						initialSnippet={initialSnippet}
						onSubmit={onSubmit}
						secondaryAction={
							<button
								type="button"
								onClick={onSkip}
								style={{
									background: 'none',
									border: 'none',
									padding: 0,
									cursor: 'pointer',
									color: 'var(--text-muted)',
									fontSize: 14,
									textDecoration: 'underline',
								}}
							>
								Skip for now
							</button>
						}
					/>
				</div>
			</div>
		</div>
	);
};
